import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Card
} from 'semantic-ui-react';
import { userConstants } from '../../constants/user.constants';

class ReportIndexScreen extends Component {
  render() {    
    const { me } = this.props;    
    
    return (  
      <Fragment>
      <h1>Relatórios</h1>        
      <h2>Solicitações</h2>
        <Card.Group itemsPerRow={3}>
            <Card 
                href='#/report/request-manager' 
                header='Solicitações por Gestor'
                description='Quantidade de solicitações e horas por gestor'>                
            </Card>
            <Card 
                href='#/report/request-user' 
                header='Solicitações por Usuário'
                description='Quantidade de solicitações e horas por usuário'>                
            </Card>
            <Card 
                href='#/report/request-all' 
                header='Solicitações'
                description='Relatório completo de todas as solicitações do sistema'>                
            </Card>
        </Card.Group>      
      <h2>Jornada de Trabalho</h2>
        <Card.Group itemsPerRow={3}>
            <Card 
                href='#/userlock/notifications' 
                header='Acessos'
                description='Relatório de ações dos usuários nas estações de trabalho'>                
            </Card>
            <Card 
                href='#/report/work-journey' 
                header='Histórico Jornada'
                description='Histórico da Jornada de trabalho por dia'>                
            </Card>            
            {me && me.Role == userConstants.ROLE_ADMIN && <Card 
                href='#/notification/log' 
                header='Notificações'
                description='Notificações Popup enviadas para os usuários'>                
            </Card>}
            {me && me.Role == userConstants.ROLE_ADMIN && <Card 
                href='#/report/last-contact' 
                header='Último Contato'
                description='Data de último contato recebido dos agentes dos usuários'>                
            </Card>}
        </Card.Group>
      {me && me.Role == userConstants.ROLE_ADMIN && <Fragment>
        <h2>Integrações</h2>
        <Card.Group itemsPerRow={3}>
            <Card 
                href='#/report/integration-log' 
                header='Logs Integração'
                description='Relatório de logs de integração com sistema de RH e Ponto'>                
            </Card>
            <Card 
                href='#/report/auth' 
                header='Logs Autenticação'
                description='Relatório de acessos de usuário no sistema'>                
            </Card>
        </Card.Group>     
        </Fragment>}
    </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { users } = state;    
  return { 
    me: users.me || null,
  };
}

const connectedReportIndexScreen = connect(mapStateToProps)(ReportIndexScreen);
export { connectedReportIndexScreen as ReportIndexScreen };
